$(function() {
    let tabs = $(".tab");
    $(".tab").on("click", function() {
        $(".active").removeClass("active");
        $(this).addClass("active");
        const index = tabs.index(this);
        $(".p-cs__size__tab__box").removeClass("show").eq(index).addClass("show");
    });
});